// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navbar_wrapper__1vk8i","logo_block":"Navbar_logo_block__3hztf","logo":"Navbar_logo__1wJmn","button_block":"Navbar_button_block__OCCPD","version":"Navbar_version__PUfxY"};